import React, { memo, useState } from "react";
import PropTypes from "prop-types";
import { Box, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { LangConstant, SystemConstant } from "const";
import { PrimaryTab, SearchBar, TabPanel } from "components";
import { useSelector } from "react-redux";
import { BranchSelectors } from "redux-store";
import SynchContact from "./SynchContact";
import ContactListTab from "./ContactListTab";
import GroupListTab from "./GroupListTab";
import AddingContact from "pages/HomePage/components/AddingContact";

const ContactTab = ({ onClick }) => {
  const classes = useStyles();
  const { t: getLabel } = useTranslation(LangConstant.NS_HOME_CONVERSATION);
  const selectedBranch = useSelector(BranchSelectors.getSelectedBranch);
  const isBranchServer = selectedBranch.type === SystemConstant.SERVER_TYPE.branch;

  const [selectedTab, setSelectedTab] = useState(CHAT_TAB_INDEX.personal);
  const [keyword, setKeyword] = useState("");

  const contactTabArray = [
    { label: getLabel(isBranchServer ? LangConstant.TXT_MEMBERS : LangConstant.TXT_MY_CONTACT) },
    { label: getLabel(LangConstant.TXT_GROUP) },
  ];

  const handleChangeSearchInput = content => {
    setKeyword(content);
  };

  const handleSynchSuccess = () => {
    handleChangeSearchInput("");
  };

  return (
    <>
      <Box className={classes.root}>
        <Box className={classes.fixedHeader}>
          <PrimaryTab
            tabArray={contactTabArray}
            onChange={setSelectedTab}
            TabIndicatorProps={{
              className: "hidden",
            }}
            selectedTabIndex={selectedTab}
            classes={{
              flexContainer: classes.flexContainer,
              tabButton: classes.tabButton,
              tabLabel: clsx(classes.tabLabel, "bold-sm-txt"),
              tabLabelSelected: classes.tabLabelSelected,
              tabButtonSelected: classes.tabButtonSelected,
            }}
          />

          <Stack direction="row">
            <SearchBar
              value={keyword}
              onChange={handleChangeSearchInput}
              classes={{
                root: classes.searchBarRoot,
              }}
            />
            {selectedTab === CHAT_TAB_INDEX.personal && (
              <SynchContact isBranchServer={isBranchServer} onSuccess={handleSynchSuccess} />
            )}
          </Stack>
        </Box>

        <TabPanel value={selectedTab} index={CHAT_TAB_INDEX.personal}>
          <ContactListTab keyword={keyword} onClick={onClick} />
        </TabPanel>

        <TabPanel value={selectedTab} index={CHAT_TAB_INDEX.group}>
          <GroupListTab keyword={keyword} onClick={onClick} />
        </TabPanel>
      </Box>

      <AddingContact isGroupTab={selectedTab === CHAT_TAB_INDEX.group} />
    </>
  );
};

ContactTab.propTypes = {
  onClick: PropTypes.func,
};

ContactTab.defaultProps = {
  onClick: () => {},
};

const CHAT_TAB_INDEX = {
  personal: 0,
  group: 1,
};

export default memo(ContactTab);

const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
  },

  flexContainer: {
    padding: "12px 14px",
  },

  tabButton: {
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    height: 30,
    minHeight: "unset",
    borderRadius: 15.5,
  },

  tabLabel: {
    marginTop: 0,
    color: "#7F7F7F",
  },

  tabLabelSelected: {
    color: "#1E272E",
  },

  tabButtonSelected: {
    backgroundColor: theme.palette.grey[100],
  },

  fixedHeader: {
    position: "sticky",
  },

  searchBarRoot: {
    marginLeft: 14,
    maxWidth: "calc(100% - 28px)",
  },
}));
